
import { ASSET_DOMAIN } from "../common/config-local";

export default {
    url(url) {
        return ASSET_DOMAIN + url;
    }
}